<div
  (click)="hideCurrentPicture()"
  *ngIf="displayCurrentPic"
  class="current-pic-wrapper"
>
  <div class="arrow-right-current-pic" (click)="moveCurrentPicNext(currentPic)">
    <fa-icon [icon]="['fas', 'arrow-circle-right']"></fa-icon>
  </div>
  <div
    class="arrow-left-current-pic"
    (click)="moveCurrentPictureBack(currentPic)"
  >
    <fa-icon [icon]="['fas', 'arrow-circle-left']"></fa-icon>
  </div>
  <div class="close-current-big-pic" (click)="hideCurrentPicture()">X</div>
  <div
    class="current-pic-frame"
    [ngClass]="{
      'current-pic-frame-big': enlargeBigPicture,
      'current-pic-frame-small': !enlargeBigPicture && isNotFirstLoad
    }"
  >
    <div
      [ngClass]="{
        'enlarge-big-picture': enlargeBigPicture,
        'minimize-big-picture': !enlargeBigPicture && isNotFirstLoad
      }"
      class="current-pic"
      id="current-pic"
    >
      <img
        src="/assets/online_design/product_exemple/{{ currentPic }}"
        (click)="preventClosingBigPic()"
      />
    </div>
  </div>
</div>
